document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".why-choose");
  const decor = document.querySelector(".why-decor-circle");

  if (!section || !decor) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        decor.classList.add("is-visible");
        observer.disconnect();
      }
    },
    {
      threshold: 0.3
    }
  );

  observer.observe(section);
});
document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".why-choose");
  if (!section) return;

  let active = false;
  let ticking = false;

  const observer = new IntersectionObserver(
    ([entry]) => {
      active = entry.isIntersecting;
    },
    { threshold: 0.1 }
  );

  observer.observe(section);

  function onScroll() {
    if (!active || ticking) return;

    ticking = true;

    requestAnimationFrame(() => {
      const rect = section.getBoundingClientRect();
      const winH = window.innerHeight;

      const progress = 1 - Math.min(
        Math.max(rect.top / winH, 0),
        1
      );

      const rotate = -15 + progress * 30; // -15 → +15
      const opacity = Math.min(progress * 1.2, 0.25);
      const translateY = 60 - progress * 60;

      section.style.setProperty("--trongdong-rotate", `${rotate}deg`);
      section.style.setProperty("--trongdong-opacity", opacity);
      section.style.setProperty("--trongdong-y", `${translateY}px`);

      ticking = false;
    });
  }

  window.addEventListener("scroll", onScroll, { passive: true });
});
